import * as React from 'react'
import { Travel } from './travel_list'
import { useJoinTravelMutation } from '../../hooks/queries/travels'

export default function JoinTravelButton({ travel }: { travel: Travel }) {
  const mutation = useJoinTravelMutation()
  if (mutation.isError) {
    return null
  }
  return (
    <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => mutation.mutate(travel.id)}>
      {mutation.isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
      {!mutation.isLoading && 'Deltag'}
    </button>
  )
}
